import React from 'react';
import LIDSitePlanner from './LIDSitePlanner';
import './App.css';

function App() {
  return (
    <div className="App">
      <LIDSitePlanner />
    </div>
  );
}

export default App;